import { HERMES_URL } from "resources/constants";
import authClient from "lib/axios/clients";

export const getRoles = async params => {
  const config = {
    method: "GET",
    url: `${HERMES_URL}/roles`,
    params
  };

  return authClient.request(config);
};

export const createRole = role => {
  const config = {
    method: "POST",
    url: `${HERMES_URL}/roles`,
    data: role
  };

  return authClient.request(config);
};

export const deleteRole = role => {
  const config = {
    method: "DELETE",
    url: `${HERMES_URL}/roles`,
    data: role
  };

  return authClient.request(config);
};
